import { Button, Grid, Box, Typography, Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux"
import WellnessScore from '../WellnessScore'
import AssessmentIcon from '@mui/icons-material/Assessment'
import SummarizeIcon from '@mui/icons-material/Summarize'
import EditIcon from '@mui/icons-material/Edit'
import { surveyClear } from "../../../reducers/survey"
import { stubTrue } from 'lodash'

const Mode2 = (props) => {
    const { user: currentUser } = useSelector((state) => state.auth);

    const DisplayModeFrame = props.DisplayModeMasterFrame.DisplayModeSQL[0]
    const navigate = useNavigate();
    const CanEdit = Number(DisplayModeFrame.SurveyDisplayMode2Frame.EditAssessmentFrame.EditAssessmentVisibleflag)
    const showStart = Number(DisplayModeFrame.SurveyDisplayMode2Frame.StartAssessmentFrame.StartAssessmentVisibleflag)
    const AssessmentGuid = DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentAssmtGuidValue
    const dispatch = useDispatch();
    const surveyStatus = useSelector(state => state.surveys.status)
    const CurrentAssessment = DisplayModeFrame.SurveyDisplayMode2Frame.CurrentAssessment[0]
    const [open, setOpen] = useState(false)
    const [guid, setGuid] = useState("")

    const currentAssessmentDate = DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentAssmtDateValue;
    const displayDate = (currentAssessmentDate ? currentAssessmentDate.split(' ')[0] : null)
    //console.log(props)
    useEffect(() => {
        if (surveyStatus === 'success') {

            dispatch(surveyClear())
        }
    }, [surveyStatus])

    const handleClose = () => {
        setOpen(false)
    }

    const handlePRClick = () => {

        if (AssessmentGuid) {

            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + AssessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    navigate({ pathname: '/personalreport', search: createSearchParams({ vi: '8AC17D1E-2871-44D9-ACC0-867285149337' }).toString() })
                })
        }
    }

    const handlePSClick = () => {


        if (AssessmentGuid) {
            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + AssessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    navigate({ pathname: '/physiciansummary', search: createSearchParams({ vi: '2C2870C1-1C00-4E67-98FF-04BA402C6824' }).toString() })
                }
                )
        }
    }


    const handleEditClick = (guid) => {
        // console.log('edit click')
        setOpen(true)
        setGuid(guid)
    }

    const handleStartEdit = () => {
        if (guid) {
            fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + props.settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + DisplayModeFrame.SurveyDisplayMode2Frame.AssessmentProductGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    //console.log(response)
                })
                .then(
                    
                    fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + guid + '/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        
                        navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701', assmtguid: guid }).toString() })
                    })
                )
        }
    }

    const handleStart = () => {
        fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + props.settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + DisplayModeFrame.SurveyDisplayMode2Frame.AssessmentProductGuid + '/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
            .then(response => response.json())
            .then(response => {
                //console.log(response)
            })
            .then(fetch('../../WsWebServicePlatform/Participant/SessionVar/Delete/' + currentUser.AuthToken + '/RESPONSE%20GUID/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {

                    navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701' }).toString() })
                }))
    }
    const JustOWS = () => {
        return (
            <Grid container xs={12}>
                <Grid item xs={12} >
                    <Typography variant="h5">{CurrentAssessment.ScoreText}</Typography>
                    <Typography variant="h4">{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentOWSValue}</Typography>
                </Grid>

                <Typography></Typography>
            </Grid>
        )
    }
    const OwsHealthAge = () => {
        return (
            <Grid container xs={12}>
                <Grid item xs={6} sx={{ borderRight: '#bfbfbf solid' }}>
                    <Typography variant="h5">{CurrentAssessment.ScoreText}</Typography>
                    <Typography variant="h4">{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentOWSValue}</Typography>
                </Grid>
                <Grid item xs={6}>

                    <Typography variant="h5">{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.HealthAgeText}</Typography>
                    <Typography variant="h4">{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentHealthAgeValue}</Typography>
                </Grid>
                <Typography></Typography>
            </Grid>
        )
    }
    return (
        <Box sx={{ textAlign: "center" }}>
            <Grid container spacing={2} direction="row">
                <Grid item xs={12} md={4}>
                    <Typography variant="h6">{CurrentAssessment.ScoreText}</Typography>
                    <Box sx={{ maxWidth: '170px', marginLeft: 'auto', marginRight: 'auto' }}>
                        <WellnessScore {...DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame} />
                    </Box>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" align='center'>{displayDate}</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Grid container spacing={1} direction="column" justifyContent={"center"} alignItems="top">
                        <Grid item xs={12}>

                            <Typography variant="h4" align="left">{CurrentAssessment.SurveyTitle}</Typography>

                        </Grid>
                        <Grid item xs={12}>

                            <Typography variant="body1" align="left">{CurrentAssessment.CompletedContent}</Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                <Grid xs={12} sm={4}>
                                    <Button sx={{ color: "#000000", fontSize: "14px" }}
                                        onClick={() => handlePRClick()}
                                    >
                                        <AssessmentIcon />
                                        {DisplayModeFrame.SurveyDisplayMode2Frame.PersonalReportFrame.PersonalReportButton}
                                    </Button>
                                </Grid>

                                {
                                    props && (CanEdit === 1) ?
                                        <Grid xs={12} sm={4}>
                                            <Button
                                                sx={{ color: "#000000", fontSize: "14px" }}
                                                onClick={() => handleEditClick(DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentAssmtGuidValue)}>
                                                <EditIcon />
                                                {DisplayModeFrame.SurveyDisplayMode2Frame.EditAssessmentFrame.EditAssessmentButton}
                                            </Button>
                                        </Grid>
                                        : null
                                }
                                {CurrentAssessment.PsViGuid != ''
                                    && (

                                        <Grid xs={12} sm={4}>
                                            <Button
                                                sx={{ color: "#000000", fontSize: "14px" }}
                                                onClick={() => handlePSClick()}
                                            >
                                                <SummarizeIcon />{DisplayModeFrame.SurveyDisplayMode2Frame.PhysicianSummaryFrame.PhysicianSummaryButton}
                                            </Button>
                                        </Grid>
                                    )
                                }
                            </Grid>

                        </Grid>
                        {
                            props && (showStart === 1) ?
                                <Grid item xs={12}>
                                    <Button variant="contained" visible
                                        onClick={() => handleStart()}
                                    >
                                        {DisplayModeFrame.SurveyDisplayMode2Frame.StartAssessmentFrame.StartAssessmentButton}
                                    </Button>
                                </Grid>
                                : null
                        }
                    </Grid>
                </Grid>




            </Grid>
            <Modal
                open={open}
                onClose={handleClose}>
                <Box sx={{
                    position: "absolute",
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { sm: 500, xs: 400 },
                    padding: "15px",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    boxShadow: 24, '& button': { m: 1 }
                }}>
                    <Typography variant="h5">{CurrentAssessment.EditAssessmentWarning.Text}</Typography>
                    <Button variant="contained" size="large" onClick={() => handleStartEdit()}>{CurrentAssessment.EditAssessmentWarning.Continue}</Button>
                    <Button variant="outlined" size="large" onClick={() => handleClose()}>{CurrentAssessment.EditAssessmentWarning.Exit}</Button>
                </Box>

            </Modal>

        </Box>
    )
}

/*


            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentAssmtDateValue}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentOWSValue}</p>
            this is where the score goes
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentHealthAgeValue}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.HealthAgeText}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.OWSText}</p>
            { props && DisplayModeFrame.SurveyDisplayMode2Frame.EditAssessmentFrame.EditAssessmentVisibleflag ? <p>{DisplayModeFrame.SurveyDisplayMode2Frame.EditAssessmentFrame.EditAssessmentButton}</p> : null}
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.PersonalReportFrame.PersonalReportGuid}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentAssmtGuidValue}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.PersonalReportFrame.PersonalReportButton}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.PhysicianSummaryFrame.PhysicianSummaryReportGuid}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.SurveyScoreFrame.CurrentAssmtGuidValue}</p>
            <p>{DisplayModeFrame.SurveyDisplayMode2Frame.PhysicianSummaryFrame.PhysicianSummaryButton}</p> */

export default Mode2